import React from "react";
import error from "@assets/images/error.svg";
import error404 from "@assets/images/404.svg"
import success from "@assets/images/success.svg";
import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom";

const StatusMsg = ({ imgUrl, status, msg, desc, btnTitle, btnOnclick }) => {
  const history = useHistory();
  return (
    <div className="bs-status-msg">
      <div className="img-wrap">
        <img src={error} alt="message icon" />
      </div>
      <div className="cont-wrap">
        <h2 className="st-title">{status}</h2>
        <div className="st-desc">
          <p>{msg}</p>
          <p>{desc}</p>
        </div>

        <div className="action-wrap">
          <Button variant="contained" onClick={btnOnclick} className="bs-btn">
            {btnTitle}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StatusMsg;
